import React from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import appState from '../../signals/appState';

const Loading = () => {
	// useSignals();

	const { loading } = appState.value;

	return (
		<div id='Loading' className={loading ? 'active' : ''}>
			<div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
		</div>
	)
}

export default Loading;